import React from 'react'
import { Box, LinearProgress, Typography } from '@material-ui/core'
import PropTypes from 'prop-types'

import { DashboardTablePaper } from 'components'

import useStyles from './styles'

const ProcessByDepartmentGraphic = ({ processStats, id, ...rest }) => {
  const classes = useStyles()

  const departments = processStats?.departments || []

  return (
    <DashboardTablePaper
      title="Processos por Departamento"
      tableType="dataProcess"
      className={classes.root}
      {...rest}
    >
      {departments?.map((department) => (
        <Box px={2} key={department.id}>
          <Box className={classes.lineTitle}>
            <Typography className={classes.rowName}>
              {department.name}
            </Typography>
            <Typography className={classes.rowValue}>
              {department.totalDataProcesses}
            </Typography>
          </Box>
          <Box>
            <LinearProgress
              className={classes.lineBar}
              variant="determinate"
              value={100}
            />
          </Box>
        </Box>
      ))}
    </DashboardTablePaper>
  )
}

ProcessByDepartmentGraphic.propTypes = {
  processStats: PropTypes.object.isRequired,
}

export default ProcessByDepartmentGraphic
